import { CommonModule, NgFor, NgIf } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ApiResponse, Item } from '../../interfaces/api-response';
import { PaginationComponent } from '../pagination/pagination.component';

@Component({
  selector: 'career-content-list',
  standalone: true,
  imports: [HttpClientModule, NgIf, CommonModule, NgFor, PaginationComponent],
  templateUrl: './content-list.component.html',
  styleUrl: './content-list.component.scss',
})
export class ContentListComponent implements OnInit {
  data: Item[] = [];
  loading = true;

  currentPage = 1;
  limit = 5;
  totalPages = 1;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.loadJobs(this.currentPage);
  }

  private loadJobs(page: number): void {
    this.loading = true;

    this.http
      .get<ApiResponse>('/api/jobs', {
        params: {
          limit: this.limit,
          page,
        },
      })
      .subscribe({
        next: (response) => {
          this.data = response.payload;
          this.currentPage = response.page ?? page;
          this.limit = response.limit ?? this.limit;
          this.totalPages = this.resolveTotalPages(response);
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  onPaginationChange(
    event: { page?: number; limit?: number } | undefined
  ): void {
    const nextLimit = Number(event?.limit);
    const nextPage = Number(event?.page);

    this.limit =
      Number.isFinite(nextLimit) && nextLimit > 0 ? nextLimit : this.limit;
    this.currentPage =
      Number.isFinite(nextPage) && nextPage > 0 ? nextPage : 1;

    this.loadJobs(this.currentPage);
  }

  private resolveTotalPages(response: ApiResponse): number {
    if (response.total_pages && response.total_pages > 0) {
      return response.total_pages;
    }

    if (response.total && this.limit > 0) {
      return Math.max(1, Math.ceil(response.total / this.limit));
    }

    const count = response.payload?.length ?? 0;
    if (count === 0) return 1;
    return count < this.limit
      ? Math.max(1, this.currentPage)
      : this.currentPage + 1;
  }

  getShortDescription(html: string): string {
    if (!html) {
      return '';
    }

    if (typeof document === 'undefined') {
      const fallback = html
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

      return fallback.length <= 496
        ? fallback
        : fallback.slice(0, 496) + ' ...';
    }

    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    const text = (tmp.textContent || tmp.innerText || '')
      .replace(/\s+/g, ' ')
      .trim();

    if (text.length <= 496) {
      return text;
    }

    return text.slice(0, 496) + ' ...';
  }

  getIconPath(type: string): string {
    const iconMap: { [key: string]: string } = {
      workfields: '/angular/browser/img/icons/workfields.svg',
      employment: '/angular/browser/img/icons/employment.svg',
      city: '/angular/browser/img/icons/location.svg',
      education: '/angular/browser/img/icons/education.svg',
    };
    return iconMap[type] || '';
  }
}
